<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10">
    <path fill="#D90338" stroke="#000" d="M1.44 8.8c.08.12.2.2.36.2h10.4c.16 0 .28-.08.36-.2.08-.12.04-.28-.04-.4l-5.2-7.2C7.24 1.08 7.12 1 7 1s-.24.08-.32.16l-5.2 7.2c-.04.08-.08.16-.08.24 0 .08 0 .12.04.2z"/>
</svg>

